import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';
import { options } from 'common/components/ContentEditor/options';
import {
    toggleBlockquote,
    unwrapBlockquote,
    unwrapList,
} from 'common/components/ContentEditor/utils/editorHelpers';

import { IToolbarButtonProps, ToolbarButton } from './ToolbarButton';

interface IProps extends IToolbarButtonProps {
    type: string;
}

export const ToolbarElement = ({ type, ...props }: IProps) => {
    const editor = useContentEditor();

    return (
        <ToolbarButton
            active={editor.api.some({ match: { type } })}
            onMouseDown={(event) => {
                event.preventDefault();

                if (!editor.selection) return;

                if (type === options.blockquote.type) {
                    toggleBlockquote(editor);

                    return;
                }

                unwrapList(editor);
                unwrapBlockquote(editor);

                editor.tf.setNodes({ type } as never);
            }}
            {...props}
        />
    );
};
